import { render, staticRenderFns } from "./BrokerInitiation.vue?vue&type=template&id=ab37a0d6&"
import script from "./BrokerInitiation.vue?vue&type=script&lang=js&"
export * from "./BrokerInitiation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports